import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("circle", { cx: 14, cy: 14, r: 14, fill: "currentColor" }),
  /* @__PURE__ */ jsx("path", { d: "M16.9673 18.4955L12.6926 14.2208L16.9673 9.93685L15.6513 8.62085L10.0513 14.2208L15.6513 19.8208L16.9673 18.4955Z", fill: "white" })
] });
const ForwardRef = forwardRef(SvgArrowLeftCircle);
export default ForwardRef;
